import { httpsCallable } from 'firebase/functions'
import { functions } from '../../db'

export interface BillingInput {
  grossMinor?: number
  discountMinor?: number
  paidMinor?: number
  method?: 'cash' | 'card' | 'transfer' | 'other'
  paymentDay?: string
}
export interface VisitWriteInput {
  date?: number | string
  isFollowUp?: boolean
  revision?: number
  billing?: BillingInput
  operationId?: string
  [field: string]: unknown
}
export interface VisitEnvelope {
  id: string
  date: number | string
  isFollowUp: boolean
  revision?: number
  status?: 'active' | 'void'
  createdAt?: number
  updatedAt?: number
  [field: string]: unknown
}
export interface Report {
  rows: Array<Record<string, any>>
  totals: Record<string, number>
  currentBalances: Record<string, number>
  migration: { status: string }
  fetchedAt: number
  currency: string
}
const cache = new Map<string, { time: number; value: unknown }>()
export function invalidateReports() {
  cache.clear()
  window.dispatchEvent(new Event('clinic-report-change'))
}
export async function reportingCall<T = any>(
  name: string,
  input: any
): Promise<T> {
  return (await httpsCallable<any, T>(functions, name)(input)).data
}
export async function getReport(
  doctorId: string,
  input: any,
  refresh = false
): Promise<Report> {
  const key = JSON.stringify([doctorId, input])
  const cached = cache.get(key)
  if (!refresh && cached && Date.now() - cached.time < 60_000) {
    return cached.value as Report
  }
  const value = await reportingCall<Report>('getClinicReport', input)
  cache.set(key, { time: Date.now(), value })
  return value
}
